if (!customElements.get('hh-announcement')) {
  customElements.define('hh-announcement', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-announcement-toggle]');
      if (!this.button) return;
      this.toggle = () => {
        const paused = this.classList.toggle('is-paused');
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel);
      };
      this.button.addEventListener('click', this.toggle);
      this.selectBlock = (event) => {
        if (this.contains(event.target) && !this.classList.contains('is-paused')) this.button.click();
      };
      this.addEventListener('shopify:block:select', this.selectBlock);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      this.removeEventListener('shopify:block:select', this.selectBlock);
    }
  });
}
